import topicsServices from '@/services/topics.services.js';
import messages from '@/constants/messages.js';

const root = { root: true };

export default {
    openDdx: async ({ dispatch }) => {
        dispatch('general/routePathRedirect', { path: `/ddx` }, root);
    },
    getSigns: async ({ commit, state, dispatch }) => {
        try {
            commit("general/setLoadingOn", null, root);
            if (!state.signs) {
                state.signs = await topicsServices.getSigns();
            }
        } catch (error) {
            dispatch("general/showError", {
                event: 'getSigns',
                error,
                message: null,
                back: true,
            }, root);
        } finally {
            dispatch("general/logEvent", 'ddx_getSigns', root);
            commit("general/setLoadingOff", null, root);
        }
    },
    postSigns: async ({ commit, dispatch, state }, { species, signs, sex }) => {
        try {
            state.diagnoses = null;
            commit("general/setLoadingOn", null, root);
            if (!species || ![1, 2].includes(species)) {
                dispatch('general/showAlert', { text: messages.DDX_REQUIRED_SPECIES }, root);
                return false;
            } else if (!signs || signs.length < 2 || !!signs.find(s => { return typeof s !== 'number' })) {
                dispatch('general/showAlert', { text: messages.DDX_REQUIRED_SIGNS }, root);
                return false;
            }
            state.diagnoses = await topicsServices.postSigns({ signs, species, sex });
            return true;
        } catch (error) {
            if (!!error && !!error.response && error.response.status == 403) {
                dispatch("purchases/openPurchases", null, root);
            } else {
                dispatch("general/showError", {
                    event: 'postSigns',
                    error,
                    message: null,
                    back: false,
                }, root);
            }
            return false;
        } finally {
            dispatch("general/logEvent", 'ddx_postSigns', root);
            commit("general/setLoadingOff", null, root);
        }
    },
    getDiagnosis: async ({ commit, state, dispatch }, { id, diagnosis }) => {
        let response;
        try {
            if (!id || !state.diagnoses || !state.diagnoses.length || !diagnosis) {
                throw new Error();
            }
            commit("general/setLoadingOn", null, root);
            if (!diagnosis['signs'] || !diagnosis['description']) {
                let diagnoses = [...state.diagnoses];
                state.diagnoses = [];
                diagnosis = await topicsServices.getDiagnosis(id);
                diagnoses.forEach(d => {
                    if (d.id == id) {
                        response = diagnosis;
                        d = { ...diagnosis };
                    }
                    state.diagnoses.push(d);
                });
            } else {
                response = diagnosis;
            }
            return response;
        } catch (error) {
            if (!!error && !!error.response && error.response.status == 403) {
                dispatch("purchases/openPurchases", null, root);
            } else {
                dispatch("general/showError", {
                    event: 'getDiagnosis',
                    error,
                    message: null,
                    back: false,
                }, root);
            }
            return false;
        } finally {
            dispatch("general/logEvent", 'ddx_getDiagnosis', root);
            commit("general/setLoadingOff", null, root);
        }
    }

}